import React from "react";
import PropTypes from "prop-types";
//import { Test } from './CommentIcon.styles';
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {
  FacebookShareButton,
  RedditShareButton,
  RedditIcon,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  TumblrShareButton,
  TumblrIcon,
} from "react-share";
const flyout = (sleeve) => (
  <Popover>
    <div style={{ padding: "20px" }}>
      <FacebookShareButton
        url={`https://www.dreamchimney.com/sleevery/sleeves/view/${sleeve.id}`}
        quote={`Sleeve #${sleeve.id}: ${sleeve.artist} "${sleeve.title}"`}
        hashtag={"#DreamChimney"}
        description={""}
        style={{ marginRight: "6px" }}
      >
        <FacebookIcon size={32} round />
      </FacebookShareButton>
      <TwitterShareButton
        title={`Sleeve #${sleeve.id}: ${sleeve.artist} "${sleeve.title}"`}
        url={`https://www.dreamchimney.com/sleevery/sleeves/view/${sleeve.id}`}
        hashtags={["DreamChimney"]}
        style={{ marginRight: "6px" }}
      >
        <TwitterIcon size={32} round />
      </TwitterShareButton>
      <TumblrShareButton
        title={`Sleeve #${sleeve.id}: ${sleeve.artist} "${sleeve.title}"`}
        caption={`Sleeve #${sleeve.id}: ${sleeve.artist} "${sleeve.title}" https://res.cloudinary.com/dreamchimney/image/upload/w_450/sleevery/${sleeve.id}.jpg`}
        url={`https://res.cloudinary.com/dreamchimney/image/upload/w_450/sleevery/${sleeve.id}.jpg`}
        tags={["DreamChimney"]}
        posttype={`photo`}
        style={{ marginRight: "6px" }}
      >
        <TumblrIcon size={32} round />
      </TumblrShareButton>
      <RedditShareButton
        url={`https://www.dreamchimney.com/sleevery/sleeves/view/${sleeve.id}`}
        title={`Sleeve #${sleeve.id}: ${sleeve.artist} "${sleeve.title}"`}
      >
        <RedditIcon size={32} round />
      </RedditShareButton>
    </div>
  </Popover>
);

const ShareIcon = ({ sleeve }) => (
  <span className="icon-wrapper">
    <OverlayTrigger trigger="click" placement="top" overlay={flyout(sleeve)}>
      {/* <button variant="success">Click me to see</button> */}
      <span>
        <i className="far fa-share-square"></i>
      </span>
    </OverlayTrigger>
  </span>
);

export default ShareIcon;
